import { z } from 'zod';
import { MODULE, RECHTE, ROLLEN } from './rechte';
import { BrandingSchema } from './branding';
import { PLATTFORM_RECHTE, PlattformLevelSchema } from './plattformLevel';
import { ADDON_FUNKTION_IDS } from './stripeAbrechnung';

export const Kuerzel = z
  .string()
  .trim()
  .toUpperCase()
  .regex(/^[A-Z0-9]{2,6}$/, '2–6 Buchstaben oder Ziffern');

/** Wie bisher in der PHP-Middleware: mindestens 10 Zeichen; Server prüft zusätzlich Name/E-Mail und bekannte Datenlecks */
export const Passwort = z.string().min(10, 'Mindestens 10 Zeichen').max(200);

export const EinrichtungSchema = z.object({
  name: z.string().trim().min(2, 'Bitte Namen angeben').max(120),
  email: z.string().trim().toLowerCase().email('Bitte gültige E-Mail angeben'),
  passwort: Passwort,
});
export type Einrichtung = z.infer<typeof EinrichtungSchema>;

export const AnmeldungSchema = z.object({
  email: z.string().trim().toLowerCase().email('Bitte gültige E-Mail angeben'),
  passwort: z.string().min(1, 'Bitte Passwort eingeben'),
  mandant: Kuerzel.nullable().default(null),
  /** „Angemeldet bleiben“: Sitzung gilt ANGEMELDET_BLEIBEN_TAGE statt nur bis kurz nach der letzten Aktivität */
  angemeldetBleiben: z.boolean().default(false),
});

/** So lange bleibt man mit „Angemeldet bleiben“ angemeldet (ab der letzten Aktivität) */
export const ANGEMELDET_BLEIBEN_TAGE = 30;
export type Anmeldung = z.infer<typeof AnmeldungSchema>;

export const CodeSchema = z.object({
  code: z.string().trim().regex(/^([0-9]{6}|[A-Za-z0-9]{4}-?[A-Za-z0-9]{4})$/, '6-stelliger Code oder Notfallcode'),
});

export const SitzungStufe = z.enum(['zweiter_faktor', 'voll']);

export const MeSchema = z.object({
  stufe: SitzungStufe,
  /** DXL sieht sich das Konto eines Marktplatzes an */
  ansicht: z.boolean(),
  csrf: z.string(),
  zweiFaktorEinrichten: z.boolean(),
  nutzer: z.object({
    id: z.string().uuid(),
    name: z.string(),
    email: z.string(),
    rolle: z.enum(ROLLEN),
    rechte: z.record(z.enum(RECHTE), z.boolean()),
    zweiFaktorAktiv: z.boolean(),
  }),
  /** Nutzer der DXL-Plattform: Rechte-Level und die daraus folgenden Plattform-Rechte (sonst null) */
  plattform: z
    .object({
      level: PlattformLevelSchema,
      rechte: z.array(z.enum(PLATTFORM_RECHTE)),
    })
    .nullable(),
  mandant: z
    .object({
      id: z.string().uuid(),
      kuerzel: z.string(),
      name: z.string(),
      module: z.array(z.enum(MODULE)),
      lizenz: z.enum(['standard', 'whitelabel']),
      branding: BrandingSchema,
      /** freigeschaltete Add-ons (Funktionen); gesperrte Bereiche zeigt die Oberfläche mit Schloss und Weg zu /paket */
      addons: z.array(z.enum(ADDON_FUNKTION_IDS)),
    })
    .nullable(),
  /** Plattform (ohne Marktplatz): gespeichertes Plattform-Branding für die Oberfläche, null = DXL-Standard */
  plattformBranding: BrandingSchema.nullable(),
});
export type Me = z.infer<typeof MeSchema>;

export const ZweiFaktorStartSchema = z.object({ secret: z.string(), uri: z.string() });
export const ZweiFaktorBestaetigtSchema = z.object({ notfallcodes: z.array(z.string()) });

export const PasswortVergessenSchema = z.object({
  email: z.string().trim().toLowerCase().email('Bitte gültige E-Mail angeben'),
  mandant: Kuerzel.nullable().default(null),
});

export const PasswortSetzenSchema = z.object({ passwort: Passwort });

export const PasswortAendernSchema = z.object({
  alt: z.string().min(1, 'Bitte aktuelles Passwort eingeben'),
  neu: Passwort,
});

export const ZugangsInfoSchema = z.object({
  art: z.enum(['einladung', 'zuruecksetzen']),
  name: z.string(),
  email: z.string(),
  mandant: z.object({ kuerzel: z.string(), name: z.string() }).nullable(),
});
export type ZugangsInfo = z.infer<typeof ZugangsInfoSchema>;
